import { api } from '@goaltree/backend/convex/_generated/api'
import { useConvexAuth, useMutation, useQuery } from 'convex/react'
import { useEffect } from 'react'

import { optimisticMarkReadByType } from '@/lib/notifs-optimistic'

// Shares the header's unreadCount subscription, so a visit only calls the
// mutation when something is unread.
export function useMarkNotifsReadOnView(type: string) {
  const { isAuthenticated } = useConvexAuth()
  const unread = useQuery(api.notifications.unreadCount, isAuthenticated ? {} : 'skip') ?? 0
  const markReadByType = useMutation(api.notifications.markReadByType).withOptimisticUpdate(
    optimisticMarkReadByType,
  )
  useEffect(() => {
    if (unread > 0) void markReadByType({ type })
  }, [unread, type, markReadByType])
}
